import { Component } from 'react';
import withBreakpoint from './withBreakpoint';

class HideAtBreakpoint extends Component {
  render() {
    const {
      breakpoints,
      breakpoint
    } = this.props;
    const matchedBreakpoint = breakpoints[breakpoint];
    return matchedBreakpoint ? null : this.props.children;
  }

}

export default withBreakpoint(HideAtBreakpoint);